import NavigationHeader from "./NavigationHeader";

import Sidebar from "./Sidebar";
import { styled } from "@mui/material/styles";
import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router";

import { useLoading } from "./LoadingContext";
import Loading from "./Loading";

const Layout = (props) => {
  const { loading } = useLoading();
  const [menuOpen, setMenuOpen] = useState(true);
  const [drawerWidth, setDrawerWidth] = useState(300);
  const [marginTop, setMarginTop] = useState(70);

  const Main = styled("main")(({ theme, open }) => ({
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

  const handleDrawerToggle = () => {
    var toggle = !menuOpen;
    setMenuOpen(toggle);
    if (toggle) {
      setDrawerWidth(300);
    } else {
      setDrawerWidth(0);
    }
  };

  const resizeTable = () => {
    const element = document.querySelector("#navigationHeader");
    var navigationHeaderHeight = element.clientHeight;
    setMarginTop(navigationHeaderHeight + 10);
  };

  useEffect(() => {
    window.addEventListener("resize", resizeTable);
    return () => {
      window.removeEventListener("resize", resizeTable); // questo non verrà mai eseguito, da capire se va bene lasciare il listener sempre attivo
    };
  }, []);

  useEffect(() => {
    let qcUrls = ["QCDetail", "QCItem", "QCDefect", "QCDefectAttachments"];
    let isQCUrl = qcUrls.some((x) => window.location.href.includes(x));
    if (isQCUrl) {
      setMenuOpen(false);
    } else {
      setMenuOpen(true);
    }
  }, [window.location.href]);

  const mainArea = React.useMemo(
    () => (
      <Main>
        {" "}
        <Outlet />{" "}
      </Main>
    ),
    []
  );

  return (
    <Box>
      <Box>
        <NavigationHeader
          handleDrawerToggle={handleDrawerToggle}
          menuOpen={menuOpen}
        />

        <Box sx={{ mt: `${marginTop}px`, ml: `${menuOpen ? "305" : "0"}px` }}>
          <Sidebar open={menuOpen}></Sidebar>
          {loading ? <Loading /> : ""}
          {mainArea}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
